<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap justify-end align-center>
				<v-flex xs12 md2>
					<v-text-field
					v-model.lazy="search"
					prepend-icon="search"
					label="Tìm kiếm"
					hide-details
					single-line
					></v-text-field>
				</v-flex>
				<v-flex xs12 md2>
					<v-menu
						:close-on-content-click="false"
						v-model="menu_month_picker"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
						:disabled="loading.getList"
					>
						<v-text-field
							slot="activator"
							v-model="chosen_month"
							label="Chọn tháng"
							:disabled="loading.getList"
							prepend-icon="event"
							readonly
							single-line
							hide-details
						></v-text-field>
						<v-date-picker
							min="2019-10"
							locale="vi-VI"
							type="month"
							v-model="chosen_month"
							@input="menu_month_picker = false"
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md2>
					<v-select
						label="Tòa nhà"
						:disabled="loading.getList"
						v-model="chosen_building"
						:items="list_building"
						prepend-icon="domain"
						required
						hide-details
						single-line
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout row wrap justify-end align-center>
				<!-- In danh sách -->
				<v-btn
					:disabled="loading.getList"
					@click="print_list = true"
					color="primary"
				>
					<v-icon small left>print</v-icon>
					In bảng công nợ
				</v-btn>
				<v-btn
					:disabled="loading.getList"
					@click="print_shorten_list = true"
					color="primary"
				>
					<v-icon small left>print</v-icon>
					In bảng công nợ rút gọn
				</v-btn>
				<v-btn
					:disabled="loading.getList"
					@click="print_list_debt_room = true"
					color="primary"
				>
					<v-icon small left>print</v-icon>
					In danh sách nợ
				</v-btn>
				<v-btn
					:disabled="loading.getList || !is_current_month"
					@click="print_list_prior_months_debt = true"
					color="primary"
				>
					<v-icon small left>print</v-icon>
					In danh sách nợ các tháng trước
				</v-btn>

				<v-btn :loading="export_csv.loading" @click="exportCSV" color="green" class="white--text">XUẤT EXCEL</v-btn>
				<export-csv-button
					:trigger="export_csv.trigger"
					:title="export_csv.title"
					:rows="export_csv.rows"
				></export-csv-button>
			</v-layout>
			<v-layout row wrap justify-center>
				<v-flex xs12>
					<v-card>
						<v-data-table
							disable-initial-sort
							:headers="headers"
							:items="items_filtered"
							:rows-per-page-items="rowPerPage"
							:loading="loading.getList"
						>	
							<template #items="props">
								<tr>
									<td class="text-center">{{ props.item.type }}</td>
									<td class="text-center">{{ props.item.account }}</td>
									<td class="text-center">{{ props.item.object }}</td>
									<td class="text-center text-no-wrap">{{ props.item.opening_balance | formatNumber }}</td>
									<td class="text-center text-no-wrap">{{ props.item.increase | formatNumber }}</td>
									<td class="text-center text-no-wrap">{{ props.item.decrease | formatNumber }}</td>
									<td class="text-center text-no-wrap">{{ props.item.end_balance | formatNumber }}</td>
									<td style="cursor: pointer" class="text-center">
											<v-edit-dialog
												large
												lazy
												@save="updateNote(props.item)"
												@open="props.item.new_note = props.item.note"
											>
											{{ props.item.note }}
											<template v-slot:input>
												<v-text-field
													v-model="props.item.new_note"
													label="Ghi chú"
													single-line
												></v-text-field>
											</template>
										</v-edit-dialog>
									</td>					
								</tr>
							</template>

							<template v-slot:footer v-if="items_filtered.length">
								<td class="text-center font-weight-bold">{{ summaryRow.type }}</td>
								<td class="text-center font-weight-bold">{{ summaryRow.account }}</td>
								<td class="text-center font-weight-bold">{{ summaryRow.object }}</td>
								<td class="text-center text-no-wrap font-weight-bold">{{ summaryRow.opening_balance | formatNumber }}</td>
								<td class="text-center text-no-wrap font-weight-bold">{{ summaryRow.increase | formatNumber }}</td>
								<td class="text-center text-no-wrap font-weight-bold">{{ summaryRow.decrease | formatNumber }}</td>
								<td class="text-center text-no-wrap font-weight-bold">{{ summaryRow.end_balance | formatNumber }}</td>					
      						</template>
							
						</v-data-table>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
		<print-portal
			layout="portrait"
			:open="print_list"
			@close="print_list = false"
		>
			<print-bang-tong-hop-cong-no :chosen_building="chosen_building" :items="items_filtered" :is_print_all="true" :summary_row="summaryRow" :chosen_month="chosen_month"></print-bang-tong-hop-cong-no>
		</print-portal>
		<print-portal
			layout="portrait"
			:open="print_shorten_list"
			@close="print_shorten_list = false"
		>
			<print-bang-tong-hop-cong-no :chosen_building="chosen_building" :items="items_filtered" :is_print_all="false" :is_print_for_customer="false" :summary_row="summaryRow" :chosen_month="chosen_month"></print-bang-tong-hop-cong-no>
		</print-portal>
		<print-portal
			layout="portrait"
			:open="print_list_debt_room"
			@close="print_list_debt_room = false"
		>
			<print-bang-tong-hop-cong-no :chosen_building="chosen_building" :items="items_filtered" :is_print_all="false" :is_print_for_customer="true" :summary_row="summaryRow" :chosen_month="chosen_month"></print-bang-tong-hop-cong-no>
		</print-portal>
		<print-portal
			layout="portrait"
			:open="print_list_prior_months_debt"
			@close="print_list_prior_months_debt = false"
		>
			<print-bang-tong-hop-cong-no :chosen_building="chosen_building" :items="items_filtered" :is_print_all="false" :is_print_for_customer="true" :is_print_prior_months_debt="true" :summary_row="summaryRow" :chosen_month="chosen_month"></print-bang-tong-hop-cong-no>
		</print-portal>
	</div>
</template>

<script>
import api from "Api";
import moment from "moment";
import {
	buildParamQuery,
	formatTimeServer,
} from "Helpers";
import { list_building, ACCOUNTING_ACCOUNT_DISPLAY_NAME_MAPPING } from "Constants/db-config";
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'
import PrintBangTongHopCongNo from "Components/Print/PrintBangTongHopCongNo"
import PrintPortal from "Components/Print/PrintPortal"

export default {
	name: "bang-tong-hop-cong-no",
	components: {
		ExportCsvButton,
		PrintPortal,
		PrintBangTongHopCongNo
	},
	data() {
		return {
			search: "",
			summaryRow: {},
			search_type: "roomId",
			headers: [
				{
					text: "Phân loại",
					align: "center",
					value: "type"
				},
				{
					text: "Tài khoản",
					align: "center",
					value: "account"
				},
				{
					text: "Đối tượng",
					align: "center",
					value: "object"
				},
				{
					text: "Số dư đầu kỳ",
					align: "center",
					value: "opening_balance"
				},
				{
					text: "Phát sinh tăng",
					align: "center",
					value: "opening_balance"
				},
				{
					text: "Phát sinh giảm",
					align: "center",
					value: "opening_balance"
				},
				{
					text: "Số dư cuối kỳ",
					align: "center",
					value: "end_balance"
				},
				{ text: "Giải trình", align: "center", value: "note", sortable: false },
			],
			list_building : [
				...list_building,
				{text: 'Tất cả', value: ''}

			],
			list_account: [1311],
			chosen_building: "",
			items: [],
			loading: {
				submit: false,
				getDetail: false,
				getList: false
			},
			rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
			menu_month_picker: false,
			chosen_month: moment().subtract(1, 'months').toISOString().substr(0, 7),
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
			},
			print_list: false,
			print_shorten_list: false,
			print_list_debt_room: false,
			print_list_prior_months_debt: false,
		};
	},
	computed: {
		user_role(){
			return this.$store.state.auth.role
		},
		is_current_month(){
			// Tháng công nợ hiện tại = tháng dương lịch - 1
			return this.chosen_month === moment().subtract(1, 'months').format("YYYY-MM");
		},
		items_filtered(){
			if (!this.search) return this.items.slice(0);

			const searchArray = this.search.toLowerCase().split(' ')
			
			if (searchArray.length > 1){
				return this.items.filter(item => item.object && searchArray.includes(item.object.toLowerCase()))
			}

			const search = searchArray[0];

			return this.items.filter(item => {
					if (
						item.object.toLowerCase().includes(search)
					)
							return true
					return false
			})
			}
	},
	watch: {
		chosen_building(){
			this.getTablesData()
		},
		chosen_month(){
			this.getTablesData()
		},
	},
	mounted() {
		this.getTablesData();
	},
	methods: {
		getTablesData: async function() {
			this.loading.getList = true;
			const last_date_of_month = this.getLastDateOfChosenMonth(this.chosen_month);
			const params = {
				building: this.chosen_building,
				[this.search_type]: this.search,
				lastDateOfMonth: last_date_of_month.clone().endOf("month").toISOString()
			};
			const query = buildParamQuery(params);
			let data = await api.getDebtReport(query);
			this.loading.getList = false;

			if (data.status === 200) {
				// only room data now
				const object = data.data[0] ? `${data.data[0].account} - ${ACCOUNTING_ACCOUNT_DISPLAY_NAME_MAPPING(data.data[0].account)}` : '';
				
				const summaryRow = {
					account: undefined,
					type: undefined,
					isSummaryRow: true,
					object,
					opening_balance: 0,
					increase: 0,
					decrease: 0,
					end_balance: 0,
				}

				data.data.forEach(row => {
				  summaryRow.opening_balance += row.opening_balance || 0;
				  summaryRow.increase += row.increase || 0;
				  summaryRow.decrease += row.decrease || 0;
				  summaryRow.end_balance += row.end_balance || 0;
				});

				this.summaryRow = summaryRow;
				
				this.items = [...data.data];
			}
		},

		getLastDateOfChosenMonth(chosen_month) {
			const start_date = new Date(chosen_month + "-01");
			return moment(start_date).endOf("month");
		},
		exportCSV: function(){
			const rows = this.items.map(item => {
				return {
					"Phân loại": item.type,
					"Tài khoản": item.account,
					"Đối tượng": item.object,
					"Số dư đầu kỳ": item.opening_balance,
					"Phát sinh tăng": item.increase,
					"Phát sinh giảm": item.decrease,
					"Số dư cuối kỳ": item.end_balance,
				}
			})
			rows.unshift({
				"Phân loại": this.summaryRow.type,
				"Tài khoản": this.summaryRow.account,
				"Đối tượng": this.summaryRow.object,
				"Số dư đầu kỳ": this.summaryRow.opening_balance,
				"Phát sinh tăng": this.summaryRow.increase,
				"Phát sinh giảm": this.summaryRow.decrease,
				"Số dư cuối kỳ": this.summaryRow.end_balance,
			})
			this.export_csv.rows = rows;
			this.export_csv.title = "bang-cong-no-thang-" + this.chosen_month;
			this.export_csv.trigger = !this.export_csv.trigger;
		},
		updateNote: async function (debt){
            const old_note = debt.note
			const data = await api.updateReceipt(`/payments/${debt.payment_id}`, { note: debt.new_note });
            if (data.status == 200){
				this.$set(debt, 'note', debt.new_note);
                swal.fire('Thành công', 'Cập nhật giải trình thành công', 'success')
            } else {
                debt.note = old_note
                swal.fire('Thất bại', data.message, 'error')
            }
		},
	}
};
</script>
